import Cookie from 'js-cookie'

const TokenKey = 'LdAdmin-Token'

export function getToken() {
    return Cookie.get(TokenKey)
}

export function setToken(token) {
    return Cookie.set(TokenKey, token)
}

export function removeToken() {
    return Cookie.remove(TokenKey)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js